import { mixed, type ValidationError } from 'yup';

/**
 * Generates a schema that validates only values from the given enum.
 */
export const oneOfEnum = (enumObject: { [s: string]: any }) =>
  mixed().oneOf(Object.values(enumObject));

export function getValidationErrorMessage(
  validationError: ValidationError | undefined,
  fieldPath: string,
): string | undefined {
  return validationError?.inner?.find((error) => error.path === fieldPath)?.message;
}
